<template>
  <div id="FrontView" class="FrontView">
    <div class="front-box">
      <div class="front-box-50">
        <div class="front-text-right">
          <p>
            <span class="front-text-hi"> Hi there!</span> <span class="front-text-nesa"> I'M NESA B.</span> <br> <br>
            I like building ideas. Enthusiastic and highly motivated software development student yearning to be an
            asset to an organization. Goal driven individual who embraces new technology with the ability to adapt to
            changing circumstances, seeking to contribute my skills to further development of the corporation while
            achieving personal growth.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'FrontView'
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.FrontView {
  background-image: url("../assets/nb-front-v2.svg");
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-position: center;
  background-color: #FFFCF4;
}

.FrontView p {
  padding: 50px, 20px;
  font-family: Corbel, FangSong, Euphemia, Sitka Text;
  color: #39170F;
  font-size: 20px;
  text-align: center;
  font-size: 1em;

}

.front-text-hi {
  font-family: Lucida Handwriting, Sitka Text;
  font-size: 1.5em;

}

.front-text-nesa {
  font-family: Garamond;
  font-size: 1.5em;
}

.front-box {
  display: block;
  margin-top: 0%;
  margin-bottom: 0%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  /*border: #42b983 solid;*/
}

.front-box-50 {
  box-sizing: border-box;
  display: block;
  max-width: 55%;
  flex-basis: 55%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 16px;
  margin-left: 2%;
  margin-right: 2%;
  line-height: 24px;
  padding-top: 20%;
  /*border: red solid;*/
}

.front-box-40 {
  box-sizing: border-box;
  display: block;
  max-width: 32%;
  flex-basis: 32%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 16px;
  margin-left: 2%;
  margin-right: 2%;
  line-height: 24px;
  width: 240px;
  /*border: pink solid;*/
  float: right;

}

.img-nb {
  background: url("../assets/nb-front-v2.svg") no-repeat;
  background-size: cover;
  padding: 50%;
  position: relative;
  background-size: contain;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

@media screen and (max-width: 1024px) {}

@media screen and (max-width: 768px) {
  .FrontView {
    background-image: url("../assets/nb-front-v2-2.svg");
  }

  .front-box-50 { 
    max-width: 96%;
    flex-basis: 96%; 
    /*border: red solid;*/
  }
}

@media screen and (max-width: 650px) {
  .FrontView {
    background-image: url("../assets/nb-front-v2-3.svg");
  }

  .front-box-50 { 
    max-width: 96%;
    flex-basis: 96%; 
    padding-top: 25%;
    /*border: red solid;*/
  }
}

@media screen and (max-width: 400px) {
  .front-box-50 { 
    max-width: 96%;
    flex-basis: 96%; 
    padding-top: 30%;
    /*border: red solid;*/
  }
}
</style>
  